import { Col } from '@opendoor/atoms/box';

import trackEvent from '../helpers/trackEvent';
import { Card } from './Card';
import { ContentCard } from './ContentCard';
import { ContentWrapper } from './ContentWrapper';
import DownloadLink from './DownloadLink';

const HOMEBUILDER_ONEPAGER_HREF =
  'https://odfil.es/static/partnership-dashboard/HB_SalesAssociate_Sheeter.pdf';
const AGENT_EDUCATIONAL_ONEPAGER =
  'https://odfil.es/static/partnership-dashboard/OpendoorForAgents_AgentAccess_One-sheeter_Final_Q423.pdf';

const DocumentsSection = () => {
  const trackDownload = (label: string) => () => {
    trackEvent('download', label, {});
  };

  return (
    <ContentWrapper>
      <ContentCard title="Additional resources">
        <Col className="gap-2.5">
          <Card className="w-full">
            <DownloadLink
              href={HOMEBUILDER_ONEPAGER_HREF}
              onClick={trackDownload('marketing-material')}
            >
              Download Homebuilder One Pager Marketing Material (PDF)
            </DownloadLink>
          </Card>
          <Card className="w-full">
            <DownloadLink
              href={AGENT_EDUCATIONAL_ONEPAGER}
              onClick={trackDownload('agent-educational-onepager')}
            >
              Download Agent Educational One Pager (PDF)
            </DownloadLink>
          </Card>
        </Col>
      </ContentCard>
    </ContentWrapper>
  );
};

export default DocumentsSection;
